import React from 'react';
import TableHeader from './TableHeader';

const Table = ({ columns, data }) => (
  <div className="overflow-x-auto w-full">
    <table className="w-full">
      <thead className="bg-gray-100 text-left">
        <tr>
          {columns.map((column, i) => (
            <TableHeader key={i} column={column} />
          ))}
        </tr>
      </thead>
      <tbody>{data}</tbody>
    </table>
  </div>
);

export default Table;
